import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import FilePicker from '../file-picker/components/file-picker';
const defaultRules = {};

const FilePickerField = ({
  name,
  control,
  rules = defaultRules,
  statusText = '',
  onChange = Function.prototype,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (newValue) => {
      field.onChange(newValue);
      onChange(newValue);
    },
    [field, onChange]
  );

  return (
    <FilePicker
      {...otherProps}
      invalid={fieldState.invalid}
      statusText={statusText || fieldState?.error?.message}
      onChange={handleChange}
    />
  );
};

export default FilePickerField;
